<template>
	<div style="height:100vh;">
		<el-container class="main-container">
			<!-- 左侧栏 -->
			<el-aside v-bind:class="asideClass">
				<left class="sidebar"></left>
			</el-aside>
			<el-container>
				<!-- 头部 -->
				<el-header class="main-header">
					<myhead>
						<el-tooltip content="刷新" class="item" effect="light" placement="right-start">
							<i class="el-icon-refresh-right refreshFont" @click="refresh"></i>
						</el-tooltip>
					</myhead>
				</el-header>
				<!-- tabs -->
				<el-row class="tabs">
					<i class="el-icon-d-arrow-left" style="padding:0 8px;"></i>
					<el-col :span="24" class="myTabs">
						<mytabs v-show="isShow1" :textList="textList" :texttit="texttit" @GetArrayList="GetArrayList" class="mybread"></mytabs>
					</el-col>
					<i class="el-icon-d-arrow-right" style="padding:0 10px;"></i>
				</el-row>
				<!-- 主体内容 -->
				<el-main class="main-center">
					<router-view v-if="isRouterAlive"></router-view>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>
<script>
	// 导入组件
	import mytabs from "@/components/tabs_whole.vue"
	import myhead from '@/components/head_whole.vue'
	import left from '@/components/left_whole.vue'

	// 导出模块
	export default {
		components: {
			left,
			myhead,
			mytabs
		},
		provide() { //刷新当前页面；在子页面写：inject: ['reload'], //注入reload方法
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isRouterAlive: true, //刷新当前页面
				asideClass: 'main-aside',
				isShow1: false,
				textList: [],
				texttit: "",
				a: 1

			}
		},

		created() {
			this.getLeft();
			this.getIsOk()
		},
		methods: {
			refresh() {
				this.reload()
			},
			reload() { //刷新当前页面
				this.isRouterAlive = false
				this.$nextTick(function() {
					this.isRouterAlive = true
				})
			},

			//左侧栏伸缩
			getLeft() {
				this.$bus.$on("myspan", e => {
					// window.console.log(e);
					if (e) {
						this.isWidth = e;
						this.ishow = false;
					} else {
						this.isWidth = "220px!important";
						this.ishow = false;
					}
				});
			},

			//tab开始
			// tab切换时，动态的切换路由
			//获取子组件的值
			getIsOk() {
				this.$bus.$on("myspan", e => {
					if (e) {
						this.isShow1 = false
					} else {
						this.isShow1 = false
					}
				});
				this.$bus.$on("myIndex", n => {
					if (n) {
						this.isShow1 = false
					} else {
						this.isShow1 = false
					}
				});
				this.$bus.$on("mycrrname", m => {
					if (m) {
						this.isShow1 = true
						this.texttit = m;
						if (this.textList.indexOf(m) == -1) {
							// window.console.log("74758785");
							this.textList.push(m);
						}
						// window.console.log(this.textList);
						this.a += 1;
					} else {
						this.isShow1 = false
					}
				})
			},
			//调用方法给传递数组赋值
			GetArrayList(val) {
				// window.console.log(val)
				this.textList = val
			}
			//tab结束

		},
	};
</script>
<style scoped="scoped">
	.myTabs {
		height: 40px;
	}
	.tabs {
		border-left: 2px solid #03152a;
		border-top: 1px solid #eee;
		height: 40px;
		display: flex;
		align-items: center;
	}
	.main-header{
		height:50px!important;
	}

	.refreshFont {
		cursor: pointer;
		line-height: 50px;
		font-size: 22px;
		font-weight: bold;
	}


	.template-tabs {
		border: 1px solid red;
	}

	.template-tabs .el-tabs {
		width: 90%;
		height: 40px;
		border: 1px solid red;
	}

	.el-tabs--border-card>.el-tabs__content {
		padding: 0px;
	}

	.main-container {
		height: 100%;
		width: 100%;
		box-sizing: border-box;
	}

	.main-aside-collapsed {
		/* 在CSS中，通过对某一样式声明! important ，可以更改默认的CSS样式优先级规则，使该条样式属性声明具有最高优先级 */
		width: 64px !important;
		height: 100%;
		background-color: #03152a;
		margin: 0px;
	}

	.main-aside {
		width: 220px !important;
		height: 100%;
		background-color: #03152a;
		margin: 0px;
	}

	.main-header,
	.main-center {
		padding: 0px;
		border-left: 2px solid #333;
	}

	.main-center {
		height: calc(100vh - 104px);
		padding: 20px 20px;
		background: #f2f2f2;
	}
</style>
